import React from 'react';
import { WarehouseOrder } from './WarehouseSystem';
import './NrOfWarehouseOrders.scss';
export function NrOfWarehouseOrders({ orders }: { orders: WarehouseOrder[] }) {
  return (
    <div className="nrOfWarehouseOrders">
      <span className="text">Nr of warehouse orders:</span>
      <span className="number">{orders.length}</span>
    </div>
  );
}
